<template>
    <v-breadcrumbs class="px-2 py-3 py-xs-2 pt-xs-4 hidden-print-only" :items="items" divider=">"></v-breadcrumbs>
</template>
<script>
export default {
    // use router to get current location
    created() {
        const route = this.$route;
        if (route.path.includes('Elections')) {
            this.items.push({
                    text: 'Elections',
                    to: { name: 'FullElections'},
                    exact: true
                }
            )
        }
        // if year
        if (route.params.year) {
            this.items.push({
                text: route.params.year,
                to: { 
                    name: 'FullElection', 
                    params: { 
                        year: route.params.year,
                        electionId: route.params.electionId
                    }
                },
                exact: true
            });
        }

        if (route.path.includes('ByDivision')) {
            this.items.push({
                text: 'Divisional Results',
                to: { name: 'DivisionalResults' },
                exact: true
            });
        }

        if (route.path.includes('Candidates') && !route.path.includes('Senate')) {
            this.items.push({
                text: 'Candidates',
                to: { name: 'Candidates'},
                exact: true
            });
        }

        if (route.path.includes('Elected') && !route.path.includes('Senate')) {
            this.items.push({
                text: 'Members Elected',
                to: { name: 'MembersElected' },
                exact: true
            });
        }

        if (route.path.includes('ByState')) {
            this.items.push({
                text: 'Senate by state',
                to: { name: 'SenateResultsByState'},
                exact: true
            });
        }

        if (route.params.division && !route.path.includes('Senate')) {
            this.items.push({
                text: route.params.division,
                to: { name: 'DivisionalResult', params: { division: route.params.division }},
                exact: true
            });
        }

        if (route.params.pollingPlace && !route.path.includes('Senate')) {
            this.items.push({
                text: route.params.pollingPlace,
                to: { name: 'PollingPlace', params: { pollingPlace: route.params.pollingPlace }},
                exact: true
            });
        }

        if (route.params.state && route.path.includes('Elections')) {
            this.items.push({
                text: route.params.state,
                to: { name: 'SenateResultByState', params: { state: route.params.state }},
                exact: true
            });
        }

        if (route.path.includes('ByCandidate')) {
            this.items.push({
                text: 'Senate State Candidate Results',
                to: { name: 'SenateResultByCandidate'},
                exact: true
            });
        }

        if (route.path.includes('ByGroup')) {
            this.items.push({
                text: 'Senate State Group Results',
                to: { name: 'SenateResultByGroup'},
                exact: true
            });
        }

        if (route.path.includes('Elected') && route.path.includes('Senate') && route.params.state) {
            this.items.push({
                text: 'Senators Elected',
                to: { name: 'SenatorsElected', params: { state: route.params.state }},
                exact: true
            });
        }

        if (route.path.includes('Elected') && route.path.includes('Senate') && !route.params.state) {
            this.items.push({
                text: 'Senators Elected',
                to: { name: 'SenatorsElectedAll'},
                exact: true
            });
        }

        if (route.path.includes('Candidates') && route.path.includes('Senate')) {
            this.items.push({
                text: 'Senate Candidates',
                to: { name: 'SenateCandidates'},
                exact: true
            });
        }
        
        if (route.params.division && route.path.includes('Senate')) {
            this.items.push({
                text: route.params.division,
                to: { name: 'SenateResultByDivision', params: { division: route.params.division }},
                exact: true
            });
        }

        if (route.params.pollingPlace && route.path.includes('Senate')) {
            this.items.push({
                text: route.params.pollingPlace,
                to: { name: 'SenatePollingPlace', params: { pollingPlace: route.params.pollingPlace }},
                exact: true
            });
        }
        if (route.path.includes('Referendums'))
        {
            this.items.push({
                text: 'Referendums',
                to: { name: 'Referendums'},
                exact: true
            })
        }

        if (route.path.includes('Referendums') && route.params.id)
        {
            this.items.push({
                text: 'Referendum',
                to: { name: 'Referendum', params: { id: route.params.id }},
                exact: true
            })
        }

        if (route.path.includes('Referendums') && route.params.state)
        {
            this.items.push({
                text: route.params.state,
                to: { name: 'ReferendumDivision', params: { state: route.params.state }},
                exact: true
            })
        }
    },
    data: () => ({
      items: []
    })
}
</script>